module.exports = __webpack_public_path__ + "static/media/MARSNEVENEKSK-Regular.ee6aa9c4.woff2";